import { render, staticRenderFns } from "./stocklevels.vue?vue&type=template&id=cd57276c&scoped=true"
import script from "./stocklevels.vue?vue&type=script&lang=js"
export * from "./stocklevels.vue?vue&type=script&lang=js"
import style0 from "./stocklevels.vue?vue&type=style&index=0&id=cd57276c&prod&scoped=true&lang=css"
import style1 from "./stocklevels.vue?vue&type=style&index=1&id=cd57276c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd57276c",
  null
  
)

export default component.exports